'use strict';

var React = require('react');

var SvgTemplateMinor = function SvgTemplateMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.833 3h-4.277v4h5.444v-2.833a1.167 1.167 0 0 0-1.167-1.167Zm1.167 6h-4v8h2.833a1.167 1.167 0 0 0 1.167-1.167v-6.833Zm-14 0h8v8h-6.833a1.167 1.167 0 0 1-1.167-1.167v-6.833Zm1.167-6a1.167 1.167 0 0 0-1.167 1.167v2.833h8.556v-4h-7.39Z"
  }));
};

exports.SvgTemplateMinor = SvgTemplateMinor;
